import LoanFromAccount from "./LoanFromAccount";

export default LoanFromAccount;